import React from 'react';
import { Check, X } from 'lucide-react';

/* Light comparison table — LinkMonkey vs competitor */
export const ComparisonTable = ({ competitor, rows }) => (
  <div className="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden" data-testid="comparison-table">
    <div className="grid grid-cols-[1.4fr_1fr_1fr] border-b border-gray-200 bg-gray-50">
      <div className="p-4 md:p-5" />
      <div className="p-4 md:p-5 text-center border-t-2 border-t-[#0055FF] bg-blue-50/40">
        <span className="font-body text-sm font-bold text-gray-950">LinkMonkey</span>
        <span className="block text-[10px] uppercase tracking-widest text-[#0055FF] mt-0.5">Pro €3.33/mo</span>
      </div>
      <div className="p-4 md:p-5 text-center">
        <span className="font-body text-sm font-semibold text-gray-500">{competitor}</span>
      </div>
    </div>
    {rows.map((row, i) => (
      <div key={i} className={`grid grid-cols-[1.4fr_1fr_1fr] items-center ${i % 2 ? 'bg-gray-50/60' : ''}`}>
        <div className="p-3.5 md:p-4 font-body text-xs md:text-sm text-gray-700">{row.label}</div>
        <div className="p-3.5 md:p-4 text-center bg-blue-50/40">
          {row.us === true
            ? <Check className="w-4 h-4 text-emerald-500 mx-auto" />
            : <span className="font-body text-[11px] md:text-xs font-medium text-emerald-700">{row.us}</span>}
        </div>
        <div className="p-3.5 md:p-4 text-center">
          {row.them === false
            ? <X className="w-4 h-4 text-gray-300 mx-auto" />
            : <span className="font-body text-[11px] md:text-xs text-gray-500">{row.them}</span>}
        </div>
      </div>
    ))}
  </div>
);
